export function trimEndSlash(source: string): string {
    let len = source.length;
    while (len > 0 && source[len - 1] === "/") len -= 1;

    return source.substring(0, len);
}
